// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../../node_modules/ui-connect/styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewSendToDevice_syncTitle__N2PP7 {
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 2px;
    border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_103"]};
}

.NewSendToDevice_syncInfo__BDHd0 {
    font-size: 13px;
}

.NewSendToDevice_device__Lz6Ly {
    position: relative;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 20px;
}

.NewSendToDevice_deviceLabel__sRIxa {
    margin-top: 8px;
    display: flex;
    align-items: center;
}

.NewSendToDevice_deviceDetails__ySnyi {
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    align-self: flex-start;
}

.NewSendToDevice_deviceName__N2BSn {
    font-size: 18px;
    font-weight: 100;
    margin-bottom: 2px;
}

.NewSendToDevice_deviceImage__ZiG5U {
    margin-right: 10px;
    width: 70px;
}

.NewSendToDevice_deviceListTitle__RPMu- {
    margin-top: 10px;
    color: gray;
    font-size: small;
}

.NewSendToDevice_deviceHelpIcon__eUDm7 {
    margin-left: 10px;
}

.NewSendToDevice_disclaimer__W1AsS {
    font-size: 12px;
}

.NewSendToDevice_deviceNote__fLZbl {
    margin-top: 10px;
}

.NewSendToDevice_cancelBtn__lZUVs {
    margin-right: 10px;
    margin-bottom: 2px;
}

.NewSendToDevice_notificationLink__LJAxI {
    white-space: nowrap;
}

.NewSendToDevice_notificationNote__nGnFq {
    text-align: left;
}

.NewSendToDevice_css_table__\\+4OrP {
    display: table;
}
.NewSendToDevice_css_tr__CMXvX {
    display: table-row;
}
.NewSendToDevice_css_td_notificationNote__aYVhW {
    display: table-cell;
    text-align: left;
    float: left;
}
.NewSendToDevice_css_td_notificationLink__ljKkf {
    display: table-cell;
    white-space: nowrap;
    vertical-align: middle;
}
.NewSendToDevice_notificationLearnMore__qA7to {
    margin-left: 10px;
}
.NewSendToDevice_notificationLearnMore__qA7to a {
    font-weight: 700;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_106"]} !important;
}

.NewSendToDevice_bottomM__44kvY {
    margin-bottom: 33px;
}
.NewSendToDevice_bottomNone__KRlur {
    margin-bottom: 0;
}

.NewSendToDevice_launchText__OrLsO {
    margin-left: 5px;
    font-size: small;
}

.NewSendToDevice_launchLable__bRVDx {
    margin-top: 5px;
}

.NewSendToDevice_dialogBody__K8GxW {
    max-height: calc(90vh - 180px);
}
`, "",{"version":3,"sources":["webpack://./src/standaloneComponents/SendToDevice/NewSendToDevice.module.css"],"names":[],"mappings":"AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,qEAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,8DAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":["@value (color_103, color_106) from 'ui-connect/styles/colors.module.css';\n\n.syncTitle {\n    text-transform: uppercase;\n    font-size: 12px;\n    letter-spacing: 2px;\n    border-bottom: 1px solid color_103;\n}\n\n.syncInfo {\n    font-size: 13px;\n}\n\n.device {\n    position: relative;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.deviceLabel {\n    margin-top: 8px;\n    display: flex;\n    align-items: center;\n}\n\n.deviceDetails {\n    -webkit-flex-grow: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    align-self: flex-start;\n}\n\n.deviceName {\n    font-size: 18px;\n    font-weight: 100;\n    margin-bottom: 2px;\n}\n\n.deviceImage {\n    margin-right: 10px;\n    width: 70px;\n}\n\n.deviceListTitle {\n    margin-top: 10px;\n    color: gray;\n    font-size: small;\n}\n\n.deviceHelpIcon {\n    margin-left: 10px;\n}\n\n.disclaimer {\n    font-size: 12px;\n}\n\n.deviceNote {\n    margin-top: 10px;\n}\n\n.cancelBtn {\n    margin-right: 10px;\n    margin-bottom: 2px;\n}\n\n.notificationLink {\n    white-space: nowrap;\n}\n\n.notificationNote {\n    text-align: left;\n}\n\n.css_table {\n    display: table;\n}\n.css_tr {\n    display: table-row;\n}\n.css_td_notificationNote {\n    display: table-cell;\n    text-align: left;\n    float: left;\n}\n.css_td_notificationLink {\n    display: table-cell;\n    white-space: nowrap;\n    vertical-align: middle;\n}\n.notificationLearnMore {\n    margin-left: 10px;\n}\n.notificationLearnMore a {\n    font-weight: 700;\n    color: color_106 !important;\n}\n\n.bottomM {\n    margin-bottom: 33px;\n}\n.bottomNone {\n    margin-bottom: 0;\n}\n\n.launchText {\n    margin-left: 5px;\n    font-size: small;\n}\n\n.launchLable {\n    margin-top: 5px;\n}\n\n.dialogBody {\n    max-height: calc(90vh - 180px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color_103": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_103"]}`,
	"color_106": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_106"]}`,
	"syncTitle": `NewSendToDevice_syncTitle__N2PP7`,
	"syncInfo": `NewSendToDevice_syncInfo__BDHd0`,
	"device": `NewSendToDevice_device__Lz6Ly`,
	"deviceLabel": `NewSendToDevice_deviceLabel__sRIxa`,
	"deviceDetails": `NewSendToDevice_deviceDetails__ySnyi`,
	"deviceName": `NewSendToDevice_deviceName__N2BSn`,
	"deviceImage": `NewSendToDevice_deviceImage__ZiG5U`,
	"deviceListTitle": `NewSendToDevice_deviceListTitle__RPMu-`,
	"deviceHelpIcon": `NewSendToDevice_deviceHelpIcon__eUDm7`,
	"disclaimer": `NewSendToDevice_disclaimer__W1AsS`,
	"deviceNote": `NewSendToDevice_deviceNote__fLZbl`,
	"cancelBtn": `NewSendToDevice_cancelBtn__lZUVs`,
	"notificationLink": `NewSendToDevice_notificationLink__LJAxI`,
	"notificationNote": `NewSendToDevice_notificationNote__nGnFq`,
	"css_table": `NewSendToDevice_css_table__+4OrP`,
	"css_tr": `NewSendToDevice_css_tr__CMXvX`,
	"css_td_notificationNote": `NewSendToDevice_css_td_notificationNote__aYVhW`,
	"css_td_notificationLink": `NewSendToDevice_css_td_notificationLink__ljKkf`,
	"notificationLearnMore": `NewSendToDevice_notificationLearnMore__qA7to`,
	"bottomM": `NewSendToDevice_bottomM__44kvY`,
	"bottomNone": `NewSendToDevice_bottomNone__KRlur`,
	"launchText": `NewSendToDevice_launchText__OrLsO`,
	"launchLable": `NewSendToDevice_launchLable__bRVDx`,
	"dialogBody": `NewSendToDevice_dialogBody__K8GxW`
};
export default ___CSS_LOADER_EXPORT___;
